import { apiPaths, getApiPath, httpStatus } from '../../constants'
import { Api } from '../../middlewares'
import { Logger, LoggerTypes } from '../../utils'

// -- GET
export const GET_GLOBAL_PRODUCTS_SUCCESS = 'GET_GLOBAL_PRODUCTS_SUCCESS'
export const GET_GLOBAL_PRODUCTS_FAILURE = 'GET_GLOBAL_PRODUCTS_FAILURE'

// -- CREATE
export const CREATE_GLOBAL_PRODUCT_SUCCESS = 'CREATE_GLOBAL_PRODUCT_SUCCESS'
export const CREATE_GLOBAL_PRODUCT_FAILURE = 'CREATE_GLOBAL_PRODUCT_FAILURE'

// -- UPDATE
export const UPDATE_GLOBAL_PRODUCT_SUCCESS = 'UPDATE_GLOBAL_PRODUCT_SUCCESS'
export const UPDATE_GLOBAL_PRODUCT_FAILURE = 'UPDATE_GLOBAL_PRODUCT_FAILURE'

// -- DELETE
export const DELETE_GLOBAL_PRODUCT_SUCCESS = 'DELETE_GLOBAL_PRODUCT_SUCCESS'
export const DELETE_GLOBAL_PRODUCT_FAILURE = 'DELETE_GLOBAL_PRODUCT_FAILURE'

// -- SELECT
export const SELECT_GLOBAL_PRODUCTS = 'SELECT_GLOBAL_PRODUCTS'

// ---------------------------------------------------------------------------

/**
 * GET list of all the global products attribute's objects.
 *
 * @returns {Promise<array<object>>}
 */
export const getGlobalProducts = () => async (dispatch) => {
  const path = apiPaths.GLOBAL_PRODUCT_LIST
  const api = new Api(path)
  const result = await api.get()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] globalProductsActions.getGlobalProducts()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: GET_GLOBAL_PRODUCTS_SUCCESS,
      data: result.data.items || []
    })
  }
  return dispatch({
    type: GET_GLOBAL_PRODUCTS_FAILURE,
    data: result.data
  })
}

/**
 * CREATE a new global product attribute.
 *
 * @param {object} newProducts New global product attribute to be created.
 * @returns {Promise<object>}
 */
export const createGlobalProduct = (newProducts) => async (dispatch) => {
  const path = apiPaths.GLOBAL_PRODUCT_CREATE
  const api = new Api(path)
  const result = await api.create(newProducts)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] globalProductsActions.createGlobalProduct()', {
    path,
    newProducts,
    result
  })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: CREATE_GLOBAL_PRODUCT_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: CREATE_GLOBAL_PRODUCT_FAILURE,
    data: result.data
  })
}

/**
 * UPDATE a specific global product attribute object.
 *
 * @param {object} newProduct New product attribute object that will replace the previous one.
 * @param {uuid} did Product UUID.
 * @returns {Promise<object>}
 */
export const updateGlobalProduct = (newProduct, did) => async (dispatch) => {
  const path = getApiPath(apiPaths.GLOBAL_PRODUCT_UPDATE, { did })
  const api = new Api(path)
  const result = await api.update(newProduct)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] globalProductsActions.updateGlobalProduct()', { path, newProduct, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: UPDATE_GLOBAL_PRODUCT_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: UPDATE_GLOBAL_PRODUCT_FAILURE,
    data: result.data
  })
}

/**
 * DELETE a specific global product attribute.
 *
 * @param {uuid} did Global product ID to be deleted.
 * @returns {Promise<string>}
 */
export const deleteGlobalProduct = (did) => async (dispatch) => {
  const path = getApiPath(apiPaths.GLOBAL_PRODUCT_DELETE, { did })
  const api = new Api(path)
  const result = await api.delete()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] globalProductsActions.deleteGlobalProduct()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: DELETE_GLOBAL_PRODUCT_SUCCESS,
      data: did
    })
  }
  return dispatch({
    type: DELETE_GLOBAL_PRODUCT_FAILURE,
    data: result.data
  })
}

/**
 * SELECT a list of global product attributes UUID.
 *
 * @param {array<uuid>} data Array of global product attributes UUID.
 * @returns {Promise<array<object>>}
 */
export const selectListGlobalProducts = (data) => async (dispatch) => {
  Logger.trace(LoggerTypes.ACTION, '[ACTION] globalProductsActions.selectListGlobalProducts()', { data })
  return dispatch({
    type: SELECT_GLOBAL_PRODUCTS,
    data
  })
}
